<template>
  <div class="matchmaker-group-page">
    <div class="group-hero">
      <div class="hero-top">
        <button class="hero-back" @click="$router.go(-1)">
          <img src="../assets/back.png" alt="">
        </button>
        <span class="hero-title">红娘团队</span>
        <div class="hero-space"></div>
      </div>
      <div class="hero-desc">了解平台红娘团队与当前跟进活跃成员</div>
    </div>

    <div class="intro-card">
      <div class="intro-title">加入红娘团队</div>
      <div class="intro-text">
        <p>如果你热心公益，大方健谈，愿意为身边的单身同事寻找合适的TA；</p>
        <p>加入红娘团队吧！</p>
        <p>红娘招募，长期有效。</p>
      </div>
    </div>

    <div class="list-card">
      <div class="list-head">
        <div class="list-title">红娘简介</div>
        <div class="list-desc">按跟进数量降序展示</div>
      </div>

      <div
        v-for="(item, index) in excellentMatchmakerInfoList"
        :key="item.id"
        class="matchmaker-row"
        @click="$router.push({ path: `/excellentMatchmaker/${item.id}` })"
      >
        <div class="rank-badge">{{ index + 1 }}</div>
          <div class="row-avatar">
            <img :src="item.avatarLink || defaultPhoto" alt="" @error="handleImageError" />
          </div>
        <div class="row-main">
          <div class="row-name">{{ item.name }}</div>
          <div class="row-meta">{{ item.department }} · {{ item.employeeNo }}</div>
        </div>
        <div class="row-side">
          <div class="row-label">跟进数量</div>
          <div class="row-value">{{ item.followUpQuantity }}</div>
        </div>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
import { getAllExcellentMatchmakerInfo } from '../api/matchmakerInfo';

export default {
  data() {
    return {
        defaultPhoto: require('../assets/defaultPhoto.png'),
      excellentMatchmakerInfoList: []
    };
  },
  methods: {
    handleImageError(e) {
      e.target.src = require('../assets/defaultPhoto.png');
    }
  },

  created() {
    getAllExcellentMatchmakerInfo().then(res => {
      if (res.code === 20000) {
        this.excellentMatchmakerInfoList = res.data
          .filter(item => item.approvalStatus === 2)
          .sort((prev, next) => {
            if (prev.followUpQuantity < next.followUpQuantity) {
              return 1;
            } else if (prev.followUpQuantity > next.followUpQuantity) {
              return -1;
            } else {
              return 0;
            }
          });
      } else {
        Toast.fail({
          message: '请求失败'
        });
      }
    });
  }
};
</script>
<style scoped lang="less" src="../style/matchmakerGroup.less" />



// WEBPACK FOOTER //
// src/views/matchmakerGroup.vue